import React from 'react';

import { BodyText } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// context and data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';
// view components
import EmailInput from 'src/viewLayer/components/shared/Inputs/EmailInput';
import CardLayout from 'src/viewLayer/components/pages/CardLayout';
import BackButton from 'src/viewLayer/components/pages/BackButton';
import SignupLink from 'src/viewLayer/components/shared/HintLinks/SignupLink';
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton';
import EmailImage from './Email.svg';
import ZendeskWidget from './ZendeskWidget';
import { t } from 'src/viewLayer/helpers/translations';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import {
  ActionsContainer,
  FormContainer,
  InputFrame,
  LoginEmailPageContainer
} from './index.styled';

export default function LoginEmailPage({
    appType,
    path,
    email,
    errorKey,
    isFocused,
    inProgress,
    onSubmit,
    onChange,
    onReset
  }) {
  useTrackPageShown({ appType,  pageType: path });
  const { queryParams, locale } = useRouteParamsContext();
  // if the user is viewing the page in German and came from a link to cancel
  const userWantsToCancelSubscription = locale === 'de' && queryParams.get('cancel');
  const pageTitleKey = userWantsToCancelSubscription ? 'email.cancel.title' : 'email.title';

  const apiError = queryParams.get('error_code')
  const errorMessages = {
    authentication_failed: t('login.b2b.error.idp_no_access'),
    account_issue: t('login.b2b.error.idp_other_error'),
    magic_link_invalid: t('login.magic_link.error_message'),
  };
  const renderApiError = errorCode => errorMessages[errorCode] || null;

  return (
    <LoginEmailPageContainer align="leading" alignItems="center">
      <CardLayout
        appType={appType}
        title={ t(pageTitleKey) }
        Image={ EmailImage }
        hideTermsAndConditions={ userWantsToCancelSubscription }
      >
        { !userWantsToCancelSubscription && <SignupLink /> }
        <BackButton trackingId="backbutton-webview-dismiss" path={ path } />
        <FormContainer>
          <form onSubmit={ onSubmit }>
            <InputFrame>
              <EmailInput
                clearValue={ onReset }
                errorKey={ errorKey }
                isFocused={ isFocused }
                disabled={ inProgress }
                onChangeHandler={ onChange }
                value={ email }
              />
            </InputFrame>
            {Object.prototype.hasOwnProperty.call(errorMessages, apiError) && (
              <BodyText size="small" textAlign="center" color={tokens.color.theme.dark.reference.red.red60} as="p">{renderApiError(apiError)}</BodyText>)}
          </form>
          <ActionsContainer>
            <TrackableButton
              id="uat-continue-button"
              fullWidth={true}
              disabled={ email.length === 0 || inProgress }
              inProgress={ inProgress }
              onClick={ onSubmit }
              title="Continue button"
              trackingId="email_continue"
              variant="primary"
            >
              { t('email.button.continue') }
            </TrackableButton>
          </ActionsContainer>
        </FormContainer>
      </CardLayout>
      <ZendeskWidget />
    </LoginEmailPageContainer>
  );
};
